import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

import { CircularProgress, Typography } from '@mui/material';


import useErrorManager from "../../../hooks/useErrorManager";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";

import GatewayInfo from './GatewayInfo';
import GwRepeatersSection from './GwRepeatersSection';
import GwNetworksSection from './GwNetworksSection';
import GwMetersSection from './GwMetersSection';
import GwFwdSection from './GwFwdSection';
import GwTariffSection from './GwTariffSection';

import { useBreadcrumb } from '../../../contexts/BreadcrumbContext'; // Import breadcrumb context

function GatewayDetails() {
    const { gatewayId } = useParams();

    const [details, setDetails] = useState(null);

    const { setError, clearError, getError } = useErrorManager();
    const [loading, setLoading] = useState(true);
    
    const { updateBreadcrumb } = useBreadcrumb(); 


    const axiosInstance = useAxiosPrivate();

    useEffect(() => {
        const fetchGatewayDetails = async () => {
            try {
                const response = await axiosInstance.get(`/gateways/${gatewayId}/details`);
                setDetails(response.data);
                clearError('fetchGwDetails');
                setLoading(false);

                updateBreadcrumb([
                    { label: 'Manage Gateways', link: '/gateways' },
                    { label: response.data.name || 'Gateway', link: null }, // Dynamically set location name
                ]);

            } catch (error) {
                setError('fetchGwDetails', error.message);
                setLoading(false);
            }
        };
        
        fetchGatewayDetails();
    }, [gatewayId]);

    if (loading) return <CircularProgress />;
    if (getError('fetchGwDetails')) return <Typography variant="h7">{getError('fetchGwDetails')}</Typography>;

    return (
        <>
            <GatewayInfo
                gatewayId={gatewayId}
                details={details}
                setDetails={setDetails}
            />
            {details.qnodeSupport && (
                <GwNetworksSection
                    gatewayId={gatewayId}
                />
            )}
            {details.dmSupport && (
                <>
                    <GwRepeatersSection
                        gatewayId={gatewayId}
                    />

                    <GwMetersSection
                        gatewayId={gatewayId}
                    />
                </>
            )}
            <GwFwdSection
                gatewayId={gatewayId}
            />
            <GwTariffSection
                gatewayId={gatewayId}
            />
        </>   
    );
}

export default GatewayDetails;
